
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[productid]/[crossreferenceid]",
      function () {
        return require("private-next-pages/product/[productid]/[crossreferenceid].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[productid]/[crossreferenceid]"])
      });
    }
  